import React from 'react';

import { User } from '@nextroll/ar-base-api';
import { ListBuilderDataType } from '@nextroll/ar-rule-builder';
import {
    RuleValidationResult, RollWorksListType, RWListRules, useListBuilderComponents,
} from '@nextroll/ar-rollworks-list-builder';


/**
 * here we hijack the data type content during unit tests
 */
const MOCK_DATA_TYPES = (process.env.JEST_WORKER_ID && process.env.NODE_ENV === 'test') && [
    {
        key: 'rollworks|third_party_company_attributes',
        disabled: false,
        hidden: false,
        object: 'third_party_company_attributes',
        objectDisplayName: 'Company Attributes',
        source: 'rollworks',
        group: 'rollworks-account-attributes',
        type: 'object',
        label: <span className='attribute-source rollworks'>Company Attributes</span>,
        shortLabel: <span className='attribute-source rollworks'>Company Attributes</span>,
    } as ListBuilderDataType,
];


// this is the exclusions type used inside the account list builder
export interface IAccountListBuilderExclusions {
    notInCrmAccounts: boolean;
    notInSalesMarketing: boolean;
    notInAdvertisingFilter: boolean;
    notInIntent: boolean;
    generalExclusionsTypes: ('competitors' | 'coworkers' | 'customers')[];
    excludedAccounts: string[];
}

interface IProps {
    advertisableEid?: string;
    user?: User;
    rules?: RWListRules;
    exclusions?: IAccountListBuilderExclusions;
    validationResult?: RuleValidationResult;
    onUpdate?: (
        rule: RWListRules | null,
        areRulesValid: boolean,
        exclusions?: IAccountListBuilderExclusions | null
    ) => void;
    ready?: boolean;
}

export const TriggerListBuilderSection = (props: IProps) => {
    const {
        banners,
        builder,
        preview,
        exclusions,
        btnPreview,
        isLoading,
        isValid,
        results,
    } = useListBuilderComponents({
        rollWorksListType: RollWorksListType.ACCOUNT,
        advertisableEid: props.advertisableEid || '',
        user: props.user,
        rules: props.rules,
        exclusions: props.exclusions,
        validationResult: props.validationResult,
        onUpdate: props.onUpdate,

        // override the internal data types here for better results in unit tests
        dataTypes: MOCK_DATA_TYPES || undefined,
    });

    return {
        banners,
        builder,
        preview,
        exclusions,
        btnPreview,
        isLoading,
        isValid,
        results,
    };
};
